import React from 'react'
import type { ReactNode } from 'react'
import { Form, Typography } from '@s4l/ds'
import type { PriceDiff as PriceDiffModel } from '@s4l/stayforlong/kernel/PriceDiff'
import { useS4LContext } from '@s4l/react-context'

import RadioSectionPlaceholder from './Placeholder'

import styles from './styles.module.css'

export interface IRadioItemProps<T> {
  value: T
  label: string
  diff: PriceDiffModel
}

export interface RadioSectionProps<TOption> {
  label: string
  info: ReactNode
  options: { map: <T>(callback: (item: TOption) => T) => T[] }
  children?: (option: TOption) => ReactNode
  perNight?: boolean
}

function RadioSection<TOption>({
  label,
  info,
  options,
  children,
  perNight = false,
}: Readonly<RadioSectionProps<TOption>>) {
  const { i18n } = useS4LContext()

  return (
    <div className={styles.container}>
      <Form.Fieldset>
        <Form.Legend>
          <span className={styles.legend}>
            {label}
            {info}
          </span>
          <Typography variant="caption" size="l" as="span">
            {perNight
              ? i18n.formatMessage({ id: 'global.pay-per-night' })
              : i18n.formatMessage({ id: 'global.per-stay' })}
          </Typography>
        </Form.Legend>
        <ul>
          {options.map(option => {
            if (!children) return null
            return children(option)
          })}
        </ul>
      </Form.Fieldset>
    </div>
  )
}

RadioSection.displayName = 'RadioSection'

RadioSection.Placeholder = RadioSectionPlaceholder

export default RadioSection
